import { render, staticRenderFns } from "./ChartjsRadarChart.vue?vue&type=template&id=1c0c9260"
import script from "./ChartjsRadarChart.vue?vue&type=script&lang=js"
export * from "./ChartjsRadarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports